import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	showMoreIconLabel: {
		id: 'team-profile-card.team-actions.more-actions.show-more-icon-label',
		defaultMessage: 'Show more',
		description: 'Show more icon label',
	},
});
